import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { MentorTrimesterAvailability, VolunteerMentorPool, VolunteerSelectedLanguageEnum, VolunteerSignupMentorStatusEnum } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService, service: VolunteeringAreaService) {

	const columns: GridColumn<VolunteerMentorPool, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 70 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 70 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 60 }),
		buildColumn(util, 'Id', row => row.volunteerId, { header: 'VolunteerId' }),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => domainData.data().volunteerStatusesMap[row.volunteerStatusId]?.name, {
			header: 'Status',
			filter: { operator: FilterOperator.Contains, value: 'Approved' }
		}),
		buildColumn(util, 'YesNo', row => row.canVolunteerInEnglish, { header: 'English Approved' }),
		buildColumn(util, 'YesNo', row => row.canVolunteerInSpanish, { header: 'Spanish Approved' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated Date', hidden: true }),
		buildColumn(util, 'Text', row => row.agreementsSigned, { header: 'Agreements', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => row.attendedOrientation, { header: 'Attended Orientation', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => !!row.interviewDateUTC, { header: 'Interviewed', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEnVideo ? 'Added' : 'Missing', { header: 'English Video', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEsVideo ? 'Added' : 'Missing', { header: 'Spanish Video', width: 80, hidden: true }),
		buildColumn(util, 'Percent', row => row.interviewScore, { header: 'Interview Score', width: 30, hidden: true }),
		buildColumn(util, 'Text', row => getSignUpStatusString(row.volunteerSignupMentorStatus.selectedTrimester), { header: service.selectedTrimesterName(), headerTooltip: `Sign-up status for ${service.selectedTrimesterName()}` }),
	];

	if (service.volunteeringData()?.selectedNextTrimester?.trimesterId) {
		columns.push(
			buildColumn(util, 'Text', row => getSignUpStatusString(row.volunteerSignupMentorStatus.selectedNextTrimester), { header: service.selectedNextTrimesterName(), headerTooltip: `Sign-up status for ${service.selectedNextTrimesterName()}` }),
		)
	}

	return columns;

}

function getSignUpStatusString(signUpStatus: MentorTrimesterAvailability): string {
	const { status, selectedLanguage, assignedLanguageId } = signUpStatus;
	if (!status) return 'Not Signed-up';
	if (status === VolunteerSignupMentorStatusEnum.Rejected) return status;
	if (status === VolunteerSignupMentorStatusEnum.Assigned && assignedLanguageId) {
		const language = assignedLanguageId === 1 ? 'English' : 'Spanish';
		return `${status} : ${language}`;
	}

	let language = '';
	switch (selectedLanguage) {
		case VolunteerSelectedLanguageEnum.BOTH: {
			language = 'Both';
			break;
		}
		case VolunteerSelectedLanguageEnum.EN: {
			language = 'English';
			break;
		}
		case VolunteerSelectedLanguageEnum.ES: {
			language = 'Spanish';
			break;
		}
	}

	return `${status} : ${language}`;
}

